import { render } from "./TempoSessao.vue?vue&type=template&id=0b19cba4&scoped=true"
import script from "./TempoSessao.vue?vue&type=script&lang=js"
export * from "./TempoSessao.vue?vue&type=script&lang=js"

import "./TempoSessao.vue?vue&type=style&index=0&id=0b19cba4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b19cba4"]])

export default __exports__